import { createSlice } from '@reduxjs/toolkit';
import ls from 'localstorage-slim';
import initialState from './feature-toggles-config';
import { Feature } from './types';

export const featureTogglesSlice = createSlice({
  /* eslint-disable no-param-reassign */ // createSlice uses immer under the hood
  name: 'featureToggles',
  initialState,
  reducers: {
    toggleFeature(
      state,
      {
        payload: { feature, on },
      }: { payload: { feature: Feature; on?: boolean } },
    ) {
      on = on ?? !state[feature].enabled;
      state[feature].enabled = on;
      if (on) {
        state[feature].dependents?.forEach((dependent) => {
          state[dependent].enabled = true;
        });
      } else {
        !on &&
          Object.values(state)
            .filter((f) => f.dependents?.includes(feature))
            .forEach((f) => {
              state[f.type].enabled = false;
            });
      }
      ls.set('featureToggles', state);
    },
  },
});

export const { toggleFeature } = featureTogglesSlice.actions;

export default featureTogglesSlice.reducer;
